import { IConnection } from "../../model/respone/IConnection"
import { IGenerateRespone } from "../../model/respone/IGenerateRespone"
import { generateActionTypeIds } from "./generateActionTypeIds"
import IGenericActionType from "./IGenericActionType"

export interface IGenerateActionRespone<T> {
    connection: IConnection,
    data: T
}
export interface IConnectionActionRespone<T> {
    connectionId: string,
    data: T
}
export const eConnectionActionTypeDefine = {
    CHANGE_CONNECTIONS: {} as IConnection[],
    CHANGE_SELECTED_ID: "",
    GENERATE_START: {} as IConnection,
    GENERATE_SUCCESS: {} as IGenerateActionRespone<IGenerateRespone>,
    GENERATE_ERROR: {} as IGenerateActionRespone<string>,

    CHANGE_SEARCH_KEY: {} as IConnectionActionRespone<string>,
    CHANGE_SELECTED_TABLE: {} as IConnectionActionRespone<string>,
    CHANGE_SELECTED_TAB: {} as IConnectionActionRespone<string>,


}
export const eConnectionActionTypeIds = generateActionTypeIds(eConnectionActionTypeDefine, "CONNECTION")

export type IConnectionActionTypes = IGenericActionType<typeof eConnectionActionTypeDefine, "CONNECTION">